import React, { useEffect, useState, useContext } from "react";
import CourseHeader from "../header2/index-two";
import FeatherIcon from "feather-icons-react";
import { Footer2 } from "../footer2/index";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import Select from "react-select";
import axiosInstance from "../../services/axiosInstance";
import { AppContext } from "../../services/AuthContext";
import { Helmet } from "react-helmet-async";
import './DatabaseAtoZ.css';
import { Testimonial03 } from "../imagepath";
import { getFilePath } from "../../services/axiosInstance";
import usePageTracking from "../../hooks/usePageTracking";


const slugify = (text) => {
  if (!text) return "";
  const trMap = { 'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u', 'Ç': 'c', 'Ğ': 'g', 'İ': 'i', 'I': 'i', 'Ö': 'o', 'Ş': 's', 'Ü': 'u' };
  return text.toString().toLowerCase()
    .split('')
    .map(c => trMap[c] || c)
    .join('')
    .replace(/\s+/g, '-')         // Boşlukları tire yap
    .trim();
};

const DatabaseAtoZ = () => {
  usePageTracking("database");
  const navigate = useNavigate();
  const location = useLocation();
  const { auth } = useContext(AppContext);
  const { id } = useParams();
  const isAll = id === 'all';

  const [allDBNames, setAllDBNames] = useState([]);
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPublication, setTotalPublication] = useState(0);
  const [filter, setFilter] = useState("");
  const [searchType, setSearchType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [topics, setTopics] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const [viewMode, setViewMode] = useState(() => localStorage.getItem('db_view') || 'grid');
  const [coverError, setCoverError] = useState(false);
  const [coverErrorMap, setCoverErrorMap] = useState({});
  const [resolvedDbName, setResolvedDbName] = useState(""); // Backend'e gidecek orijinal isim

  useEffect(() => { localStorage.setItem('db_view', viewMode); }, [viewMode]);

  const headers = auth.token ? { Authorization: `Bearer ${auth.token}` } : {};

  useEffect(() => {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      // fallback for environments where window.scrollTo may not be available
      window.scrollTo(0, 0);
    }
  }, [currentPage]);

  const formatDbTitle = (rawName) => {
    if (!rawName) return "";
    const clean = rawName.trim();
    if (/veri\s*taban[ıi]/i.test(clean)) {
      return clean;
    }
    return `${clean} Veritabanı`;
  };

  const getBannerTitle = () => {
    if (isAll) return "Tüm Veri Tabanları";
    const name = resolvedDbName || location.state?.databasename || (id ? decodeURIComponent(id) : "");
    if (!name) return "Veri Tabanları";
    return formatDbTitle(name);
  };

  useEffect(() => {
    let mounted = true;

    const loadAndCheckUrl = async () => {
      try {
        // 1. Kullanıcının yetkili olduğu veritabanlarını çek
        const resp = await axiosInstance.get(
          "databases/search/databaseList/1",
        );
        const dbList = resp?.data.data || [];
        console.log(dbList);
        const names = dbList.map(x => x.name).filter(Boolean);

        if (mounted) {
          setAllDBNames(names);

          if (id !== 'all') {
            const iconDbMap = {
              'akademik-dergiler': 'Akademik Dergiler',
              'populer-dergiler': 'Popüler Dergiler',
              'akademik-kitaplar': 'Akademik Kitap',
              'populer-kitaplar': 'Popüler Kitap',
              'tip-kitaplari': 'İdeal Tıp Kitapları',
              'tip-&-saglik-bilimleri': 'İdeal Tıp Kitapları',
              'din-bilimleri': 'Din Bilimleri',
              'bildiri-armagan': 'Konferans & Armağanlar',
              'konferans-&-armagan': 'Konferans & Armağanlar',
              'sosyal-bilimler': 'İdeal Sosyal Bilimler Veritabanı',
            };
            const mappedName = iconDbMap[id];
            // 2. URL'deki id ile listedeki veritabanlarını slugify ederek karşılaştır
            const foundName = names.find(name => 
              slugify(name) === slugify(id) || 
              (mappedName && slugify(name) === slugify(mappedName)) ||
              slugify(name).includes(slugify(id))
            );

            if (foundName) {
              setResolvedDbName(foundName);

              // 3. EĞER URL hatalıysa (boşluk varsa veya case hatalıysa) URL'i düzelt
              const correctSlug = slugify(foundName);
              if (id !== correctSlug) {
                navigate(`/database/${correctSlug}`, { replace: true });
              }
            } else {
              // Eşleşme yoksa (belki manuel girildi) gelen id'yi olduğu gibi kullanmayı dene
              setResolvedDbName(mappedName || id);
            }
          }
        }
      } catch (e) {
        console.error("Setup error:", e);
      }
    };

    loadAndCheckUrl();
    return () => { mounted = false; };
  }, [id, auth.token]);

  useEffect(() => {
    if (!isAll) return;
    let mounted = true;
    (async () => {
      try {
        const resp = await axiosInstance.get(
          "databases/search/databaseList/1",
        );
        const names = (resp?.data.data || []).map(x => x.name).filter(Boolean);
        if (mounted) setAllDBNames(names);
      } catch (e) {
        if (mounted) setAllDBNames([]);
        console.error("userInstutationDatabases error:", e);
      }
    })();
    return () => { mounted = false; };
  }, [isAll, auth.token]);

  const journalType = isAll ? 'all' : (allDBNames.includes(id) ? 'single' : 'none');

  const fetchTopics = async () => {
    try {
      const url = "publicationSearch/journalsTopicsList";

      let list = isAll ? allDBNames : [resolvedDbName];
      if (list.length === 0 || (id !== 'all' && !resolvedDbName)) return;

      if (list.length === 0 && journalType !== 'all') {
        setTopics([{ value: "", label: "Tümü" }]);
        return;
      }

      if (journalType === 'all' && allDBNames.length === 0) {
        setTopics([{ value: "", label: "Tümü" }]);
        return;
      }


      const response = await axiosInstance.post(
        url,
        { list },
        { headers: { ...headers, "Content-Type": "application/json" } }
      );

      if (response?.data?.status === "OK") {
        const formattedTopics = (response.data.data || []).map((t) => ({
          value: t.key,
          label: `${t.key} (${t.value})`,
        }));
        formattedTopics.unshift({ value: "", label: "Tümü" });
        setTopics(formattedTopics);
      } else {
        setTopics([{ value: "", label: "Tümü" }]);
      }
    } catch (error) {
      console.error("Error fetching topics:", error);
      setTopics([{ value: "", label: "Tümü" }]);
    }
  };

  useEffect(() => {
    if (initialized) {
      fetchTopics();
    }
    // eslint-disable-next-line
  }, [id, auth.token, initialized, isAll, allDBNames]);

  useEffect(() => {
    // Yeni veritabanına geçildiğinde filtreleri temizle
    setSearchQuery("");
    setFilter("");
    setCurrentPage(1);
  }, [id]); // id değiştiğinde tetiklenir

  const fetchPublications = async (page = 1) => {
    if (id !== 'all' && !resolvedDbName) return;
    setLoading(true);
    try {
      const url = `publicationSearch/AtoZNotParents?page=${page}`;

      let searchkeyword = searchQuery || "";
      const typeForApi = searchkeyword ? (searchType || "journalName") : "";

      const params = {
        databasename: isAll ? allDBNames : [resolvedDbName],
        searchkeyword,
        topicname: filter || "",
        searchtype: typeForApi,
      };

      const response = await axiosInstance.post(url, params, { headers });
      if (response.data && response.data.status === "OK") {
        setPublications(response.data.data || []);
        const totalItems = response.data.count || 0;
        setTotalPublication(totalItems);
        setTotalPages(Math.ceil(totalItems / 20));
      } else {
        setPublications([]);
        setTotalPublication(0);
        setTotalPages(1);
      }
    } catch (error) {
      console.error("Error fetching AtoZNotParents publications:", error);
      setPublications([]);
      setTotalPublication(0);
      setTotalPages(1);
    } finally {
      setLoading(false); // Yükleniyor durumunu sonlandır
    }
  };

  useEffect(() => {
    if (location.state) {
      const { databasename, searchkeyword, topicname, searchtype } = location.state;
      if (databasename) {
        if (id === databasename) {
          setSearchQuery(searchkeyword || "");
          setSearchType(searchtype || "");
          setFilter(topicname || "");
          setCurrentPage(1);
        }
      } else if (searchkeyword || isAll) {
        setSearchQuery(searchkeyword || "");
        setSearchType(searchtype || "journalName");
        setFilter(topicname || "");
        setCurrentPage(1);
      }
      setInitialized(true);
    } else {
      setInitialized(true);
    }
    // eslint-disable-next-line
  }, [location.state, id]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchPublications(page);
  };

  useEffect(() => {
    if (initialized) fetchPublications(currentPage);
    // eslint-disable-next-line
  }, [id, isAll, filter, searchType, searchQuery, auth.token, initialized, allDBNames]);



  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setSearchType("journalName");
    // setFilter("");
    setCurrentPage(1);
  };

  const handleFilter = (char) => {
    if (char === "") {
      setSearchType("");
      setSearchQuery("");
    } else {
      setSearchType("journalNameStart");
    }
    setSearchQuery(char);
    setCurrentPage(1);
  };

  const handleTopicChange = (selectedOption) => {
    setFilter(selectedOption?.value || "");
    setCurrentPage(1);
  };

  const getMatchingTitle = (pub, filter) => {
    const titleAttribute = pub.publicationtypeInfo?.find(
      (attr) => attr.attributename === "Başlık"
    );

    if (!titleAttribute || !Array.isArray(titleAttribute.value)) return "-";

    const trTitles = titleAttribute.value.filter(item => item.lang === 'tr');
    const enTitles = titleAttribute.value.filter(item => item.lang === 'en');
    const firstTitle = titleAttribute.value[0];

    // Eğer A-Z araması yapılıyorsa ("journalNameStart")
    if (searchType === "journalNameStart" && filter) {
      const regexp = new RegExp(`^${filter}`, "i");
      let trMatch = null;

      // Türkçe başlıklarda filtreyle başlayan var mı?
      for (const item of trTitles) {
        if (item.value && item.value[0] && regexp.test(item.value[0])) {
          trMatch = item.value[0];
          break;
        }
      }

      // Eğer Türkçe başlık eşleşmediyse İngilizceye bak
      if (!trMatch) {
        for (const item of enTitles) {
          if (item.value && item.value[0] && regexp.test(item.value[0])) {
            return item.value[0];
          }
        }
      }

      // Türkçe eşleştiyse onu döndür
      if (trMatch) return trMatch;
    }

    // Normal durumda (A-Z araması değilken)
    if (trTitles.length > 0) {
      const tr = trTitles[0].value?.[0];
      if (tr) return tr;
    }

    // Eğer Türkçe yoksa İngilizce başlığı döndür
    if (enTitles.length > 0) {
      const en = enTitles[0].value?.[0];
      if (en) return en;
    }

    // En son fallback: ilk mevcut başlık
    if (firstTitle?.value?.[0]) return firstTitle.value[0];

    return "-";
  };

  const getTags = (pub) => {
    const extractAttrArr = (list, attrName) => {
      if (!Array.isArray(list)) return [];
      const attr = list.find(a => a.attributename === attrName);
      if (!attr || !attr.value) return [];
      if (Array.isArray(attr.value)) {
        const trVal = attr.value.find(v => v.lang === "tr" && Array.isArray(v.value))?.value;
        if (trVal) return trVal;
        const firstVal = attr.value.find(v => Array.isArray(v.value))?.value;
        if (firstVal) return firstVal;
        if (typeof attr.value[0] === 'string') return attr.value;
      }
      return [];
    };

    const pubTypeTopics = extractAttrArr(pub?.publicationtypeInfo, "Konu Başlıkları");
    const pubTypeKeywords = extractAttrArr(pub?.publicationtypeInfo, "Anahtar Kelimeler");
    const templateTopics = extractAttrArr(pub?.templateInfo, "Konu Başlıkları");
    const templateKeywords = extractAttrArr(pub?.templateInfo, "Anahtar Kelimeler");

    const all = [
      ...pubTypeTopics,
      ...templateTopics,
      ...pubTypeKeywords,
      ...templateKeywords,
    ]
      .map(x => (typeof x === "string" ? x.trim() : String(x).trim()))
      .filter(Boolean);

    return Array.from(new Set(all));
  };
  const getJournalFields = (pub) => {
    const publisher = pub.publishers?.[0] || null;
    const periyot =
      pub.templateInfo?.find(a => a.attributename === "Periyot")
        ?.value?.[0]?.value?.[0] ||
      pub.publicationtypeInfo?.find(a => a.attributename === "Periyot")
        ?.value?.[0]?.value?.[0] ||
      "";

    const issn =
      pub.publicationtypeInfo?.find(a => a.attributename === "ISSN")
        ?.value?.[0]?.value?.[0] || "";

    const son =
      pub.templateInfo?.find(a => a.attributename === "Son Yayınlandığı Tarih")
        ?.value?.[0]?.value?.[0] || "";
    const yayin =
      pub.templateInfo?.find(a => a.attributename === "Yayın Tarihi")
        ?.value?.[0]?.value?.[0] || "";
    const tarih = (son || yayin)?.toString().match(/\d{4}/)?.[0] || "";

    return [
      publisher && {
        label: "Yayıncı",
        value: publisher.sorttitle || publisher.title,
        href: `/publisher-detail/${publisher.mysqlId}`,
        onClick: () => navigate(`/publisher-detail/${publisher.mysqlId}`)
      },
      periyot && { label: "Periyot", value: periyot },
      issn && { label: "ISSN", value: issn },
      tarih && { label: "Tarih", value: tarih },
    ].filter(Boolean);
  };

  const renderPublication = (pub, index) => {
    const title = getMatchingTitle(pub, searchQuery);

    const volume = pub.publicationtypeInfo?.find(
      (attr) => attr.attributename === "Cilt"
    )?.value?.[0]?.value?.[0];

    // Eğer cilt bilgisi varsa başlığın yanına ekle
    const displayTitle = volume ? `${title} (${volume})` : title;

    const authorsArr = pub.authors || [];
    const tags = getTags(pub);
    const fields = getJournalFields(pub);

    const coverImage = (pub.coverimage && !coverErrorMap[pub.mysqlId])
      ? getFilePath(`publications/search/displayFile/${pub.mysqlId}/${pub.coverimage}`)
      : Testimonial03;

    const MetaLine = () => (
      <div className="mb-2 text-darkfume small" style={{ fontSize: '0.95em' }}>
        {fields.map((f, i) => (
          f.href ? (
            <a
              key={i}
              href={f.href}
              className="text-darkfume"
              style={{ textDecoration: 'none', padding: '0 1px' }}
              onClick={(e) => { e.preventDefault(); f.onClick && f.onClick(); }}
              onMouseOver={(e) => (e.currentTarget.style.textDecoration = "underline")}
              onMouseOut={(e) => (e.currentTarget.style.textDecoration = "none")}
            >
              {f.value}{i < fields.length - 1 ? ' | ' : ''}
            </a>
          ) : (
            <span key={i}>{f.value}{i < fields.length - 1 ? ' | ' : ''}</span>
          )
        ))}
      </div>
    );

    if (viewMode === 'grid') {
      return (
        <div className={"col-md-6 col-lg-4 col-xl-3"} key={index}>
          <div className="card h-100 shadow-sm border rounded-3 bg-white">
            {coverImage && (
              <div className="d-flex justify-content-center align-items-center pt-3">
                <Link to={`/publication-details/${pub.mysqlId}`}>
                  <img
                    src={coverImage}
                    alt={title}
                    className="img-fluid rounded-3"
                    style={{ height: 140, objectFit: 'contain' }}
                    onError={() => setCoverErrorMap(prev => ({ ...prev, [pub.mysqlId]: true }))}
                  />
                </Link>
              </div>
            )}
            <div className="card-body pb-2">
              <h5 className="card-title text-newdarkfume text-sm fw-bold mb-2" style={{ minHeight: 40 }}>
                <Link
                  to={`/publication-details/${pub.mysqlId}`}
                  className="text-newdarkfume text-decoration-none"
                  dangerouslySetInnerHTML={{ __html: displayTitle }}
                />
              </h5>

              {authorsArr.length > 0 && (
                <div className="mb-1 text-darkfume text-sm">
                  <b>Yazarlar:</b> {authorsArr.map(a => `${a.name} ${a.surname}`).join(", ")}
                </div>
              )}

              <MetaLine />

              {/* tags */}
              <div className="mb-1">
                {tags.map((t, i) => (
                  <span
                    key={i}
                    className="badge bg-light border text-newdarkfume me-1 small"
                    style={{ fontWeight: 500, border: "1px solid #e0e2f5" }}
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }

    // LIST view (DatabaseList'teki gibi)
    return (
      <div className="col-12" key={index}>
        <div className="card shadow-sm border rounded-3 bg-white">
          <div className="row g-0 align-items-center">
            {coverImage && (
              <div className="col-auto p-3">
                <Link to={`/publication-details/${pub.mysqlId}`}>
                  <img
                    src={coverImage}
                    alt={title}
                    className="img-fluid rounded-3"
                    style={{ height: 140, objectFit: 'contain' }}
                    onError={() => setCoverError(true)}
                  />
                </Link>
              </div>
            )}
            <div className="col">
              <div className="card-body py-3">
                <h6 className="mb-1 fw-semibold">
                  <Link
                    to={`/publication-details/${pub.mysqlId}`}
                    className="text-newdarkfume text-decoration-none"
                    dangerouslySetInnerHTML={{ __html: displayTitle }}
                  />
                </h6>

                {authorsArr.length > 0 && (
                  <div className="text-darkfume text-sm mb-1">
                    <b>Yazarlar:</b> {authorsArr.map(a => `${a.name} ${a.surname}`).join(", ")}
                  </div>
                )}

                <MetaLine />
              </div>
            </div>
            <div className="col-auto pe-3">
              <Link to={`/publication-details/${pub.mysqlId}`} className="btn btn-sm btn-outline-newdarkfumetogreen rounded">
                Detay
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;
    const maxPageButtons = 10;
    let startPage = Math.max(1, currentPage - 5);
    let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
    if (endPage - startPage < maxPageButtons - 1) {
      startPage = Math.max(1, endPage - maxPageButtons + 1);
    }
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
    return (
      <ul className="pagination lms-page justify-content-center d-flex gap-1">
        <li className={`page-item first ${currentPage === 1 ? "disabled" : ""}`}>
          <button className="btn btn-outline-primary btn-sm text-xs me-2" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>{"<<"}</button>
        </li>
        <li className={`page-item prev ${currentPage === 1 ? "disabled" : ""}`}>
          <button className="btn btn-outline-primary btn-sm text-xs me-2" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}><i className="fas fa-angle-left" /></button>
        </li>
        {pageNumbers.map((page) => (
          <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
            <button className={`btn btn-sm text-xs me-2 ${currentPage === page ? "bg-primary text-white" : "btn-outline-primary"}`} onClick={() => handlePageChange(page)} disabled={currentPage === page}>{page}</button>
          </li>
        ))}
        <li className={`page-item next ${currentPage === totalPages ? "disabled" : ""}`}>
          <button className="btn btn-outline-primary btn-sm text-xs me-2" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}><i className="fas fa-angle-right" /></button>
        </li>
        <li className={`page-item last ${currentPage === totalPages ? "disabled" : ""}`}>
          <button className="btn btn-outline-primary btn-sm text-xs me-2" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>{">>"}</button>
        </li>
      </ul>
    );
  };

  return (
    <div className="main-wrapper">
      <Helmet>
        <title>İdealonline - {getBannerTitle()}</title>
      </Helmet>
      <CourseHeader activeMenu={"Veritabanları"} />
      <section className="py-5 mt-4">
        <div className="dblist-container">
          <div className="row justify-content-center mb-4">
            <div className="col-12">
              <div className="modern-search-banner rounded-2 mb-4">
                <div className="row g-4">

                  {/* Sol Widget Wrap: Başlık, Açıklama, Form */}
                  <div className="col-lg-9 col-md-8">
                    {/* Başlık */}
                    <h1 className="search-banner-title">{getBannerTitle()}</h1>

                    {/* Açıklama */}
                    <p className="search-banner-description">
                      Yayın adı, konu veya anahtar kelimeyle arama yaparak en uygun kaynaklara ulaşın.
                    </p>

                    {/* Filter Listing Form */}
                    <div className="filter-listing-form">
                      <form onSubmit={(e) => { e.preventDefault(); /* Arama fonksiyonu */ }}>
                        <div className="row align-items-center g-2">

                          {/* 1. Dergi Adıyla Arama: col-md-5 -> col-md-7 (daha geniş olacak) */}
                          <div className="col-md-7">
                            <div className="input-group border-0">
                              <span className="input-group-text border-0"><FeatherIcon icon="search" className="text-darkfume" /></span>
                              <input
                                type="text"
                                className="form-control border-0 text-fume"
                                placeholder="Yayın ismi ile arayın..."
                                value={searchType === "journalNameStart" ? "" : searchQuery}
                                onChange={handleSearch}
                              />

                            </div>
                          </div>

                          {/* 2. Konu Seçimi: col-md-3 -> col-md-3 (aynı kalabilir) */}
                          <div className="col-md-3">
                            <Select
                              options={topics}
                              placeholder="Konu"
                              onChange={handleTopicChange}
                              value={topics.find(t => t.value === filter) || ""}
                              // isClearable
                              classNamePrefix="react-select"
                              styles={{
                                control: (base) => ({ ...base, minHeight: 50, borderRadius: 8 }),
                              }}
                            />
                          </div>

                          <div className="col-md-2">
                            <button
                              type="submit"
                              className="btn btn-submit-search"
                            >
                              Ara
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>

                  </div>

                  {/* Sağ Widget Wrap: A-Z Filtresi */}
                  <div className="col-lg-3 col-md-4 d-flex justify-content-end align-items-center">
                    <div className="ideal-az-grid">
                      {"ABCÇDEFGHIİJKLMNOÖPQRSŞTUÜVWXYZ"
                        .split("")
                        .map((char) => (
                          <button
                            key={char}
                            className={`az-letter-button ${searchQuery === char ? "active-char" : ""}`}
                            onClick={() => handleFilter(char)}
                          >
                            {char}
                          </button>
                        ))}
                    </div>
                  </div>
                </div>
              </div>


            </div>
            <div className="d-flex align-items-center gap-2 mt-3">
              <div className="text-sm fw-semibold text-muted">
                Toplam {totalPublication} sonuç bulundu.
              </div>
              <div className="ms-auto btn-group" role="group" aria-label="View switcher">
                <button
                  type="button"
                  className={`btn btn-sm ${viewMode === 'grid' ? 'btn-newdarkfume' : 'btn-outline-newdarkfume'}`}
                  onClick={() => setViewMode('grid')}
                  title="Grid view"
                >
                  <FeatherIcon icon="grid" className="me-1" /> Grid
                </button>
                <button
                  type="button"
                  className={`btn btn-sm ${viewMode === 'list' ? 'btn-newdarkfume' : 'btn-outline-newdarkfume'}`}
                  onClick={() => setViewMode('list')}
                  title="List view"
                >
                  <FeatherIcon icon="list" className="me-1" /> Liste
                </button>
              </div>
            </div>
          </div>

          <div className={`row ${viewMode === 'grid' ? 'g-4' : 'gy-0'}`}>
            {loading ? (
              <div className="col-12 text-center my-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Yükleniyor...</span>
                </div>
                <p className="mt-2 text-darkfume">Yayınlar yükleniyor...</p>
              </div>
            ) : publications.length === 0 ? (
              <div className="col-12">
                <div className="alert alert-danger text-center mt-4 rounded-4">
                  Aradığınız kriterlere uygun sonuç bulunamadı.
                </div>
              </div>
            ) : (
              publications.map(renderPublication)
            )}
          </div>


          <div className="row mt-4">
            <div className="col-12 d-flex justify-content-center">
              {renderPagination()}
            </div>
          </div>
        </div>
      </section>

      <Footer2 />
    </div>
  );
};

export default DatabaseAtoZ;